<template>
  <kst-page-print pageFooter
    v-slot="{ title }"
    :catalog="OmzSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
        <div class="is-flex">
          {{ Catalog.Total.Label}}:
          <kst-value class="ks-space-left"
            field="Total" :data="summaryData" :catalog="Catalog"
          />
        </div>
      </div>
    </div>

    <List class="block" :summaryData="summaryData"/>
  </kst-page-print>
</template>

<script>
import Catalog from "../OmzCatalog.js";
import Model from "../OmzModel.js";
import OmzSearchCatalog from "../OmzSearchCatalog.js";
import Services from "../../../services/Api/OmzetServices.js";

import List from "./OmzP_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    OmzSearchCatalog: OmzSearchCatalog,
    companyData: {},
    summaryData: {},
    searchData: {
      Date: null,
      WarehouseID: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintData(options);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.summaryData = Model.Print.getSummary(data.TransactionDetails);
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.summaryData = Model.createSummary();
    },

    resetSearch() {
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },

    getListOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID)
      };
    }
  }
}
</script>